import { getMostOccurenceInArray } from "../../../../../../utils";

const mapTotalReport = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,
          "Current Tier": t.tier,
          Transactions: t.payment?.total_transaction ?? 0,
          "Quantity (units)": t.payment?.total_qty ?? 0,
          "Total Revenue (THB)": t.payment?.total_revenue ?? 0,
          "Total Earn (points)":
            (t.payment?.total_earn?.reward ?? 0) +
            (t.earn?.reward?.total_amount ?? 0),
        };
      });
};

const makeTotalSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: `Total`,
        "Current Tier": "",
        Transactions: row["Transactions"] + total["Transactions"],
        "Quantity (units)": row["Quantity (units)"] + total["Quantity (units)"],
        "Total Revenue (THB)":
          row["Total Revenue (THB)"] + total["Total Revenue (THB)"],
        "Total Earn (points)":
          row["Total Earn (points)"] + total["Total Earn (points)"],
      };
    },
    {
      Name: `Total`,
      "Current Tier": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Revenue (THB)": 0,
      "Total Earn (points)": 0,
    }
  );
};

const mapEarnReport = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,
          "Current Tier": t.tier,
          Transactions: t.payment?.total_transaction ?? 0,
          "Quantity (units)": t.payment?.total_qty ?? 0,
          "Total Revenue (THB)": t.payment?.total_revenue ?? 0,
          "Total Earn (points)":
            (t.payment?.total_earn?.reward ?? 0) +
            (t.earn?.reward?.total_amount ?? 0),
        };
      });
};

const makeEarnSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: `Total`,
        "Current Tier": "",
        Transactions: row["Transactions"] + total["Transactions"],
        "Quantity (units)": row["Quantity (units)"] + total["Quantity (units)"],
        "Total Revenue (THB)":
          row["Total Revenue (THB)"] + total["Total Revenue (THB)"],
        "Total Earn (points)":
          row["Total Earn (points)"] + total["Total Earn (points)"],
      };
    },
    {
      Name: `Total`,
      "Current Tier": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Revenue (THB)": 0,
      "Total Earn (points)": 0,
    }
  );
};

const mapRedeemReport = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,
          "Current Tier": t.tier,
          Transactions: t.payment?.total_transaction ?? 0,
          "Quantity (units)": t.payment?.total_qty ?? 0,
          "Total Revenue (THB)": t.payment?.total_revenue ?? 0,
          "Total Redeem (points)":
            Math.abs(t.payment?.total_redeem?.reward) ?? 0,
        };
      });
};

const makeRedeemSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: `Total`,
        "Current Tier": "",
        Transactions: row["Transactions"] + total["Transactions"],
        "Quantity (units)": row["Quantity (units)"] + total["Quantity (units)"],
        "Total Revenue (THB)":
          (row["Total Revenue (THB)"] ?? 0) + total["Total Revenue (THB)"],
        "Total Redeem (points)":
          (row["Total Redeem (points)"] ?? 0) + total["Total Redeem (points)"],
      };
    },
    {
      Name: `Total`,
      "Current Tier": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Revenue (THB)": 0,
      "Total Redeem (points)": 0,
    }
  );
};

const mapRemainingReport = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,
          "Current Tier": t.tier,
          Transactions: t.payment?.total_transaction ?? 0,
          "Quantity (units)": t.payment?.total_qty ?? 0,
          "Total Revenue (THB)": t.payment?.total_revenue ?? 0,
          "Total Remaining (points)":
            (t.payment?.total_earn?.reward ?? 0) +
            (t.earn?.reward?.total_amount ?? 0) +
            (t.payment?.total_redeem?.reward ?? 0),
        };
      });
};

const makeRemainingSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: `Total`,
        "Current Tier": "",
        Transactions: row["Transactions"] + total["Transactions"],
        "Quantity (units)": row["Quantity (units)"] + total["Quantity (units)"],
        "Total Revenue (THB)":
          row["Total Revenue (THB)"] + total["Total Revenue (THB)"],
        "Total Remaining (points)":
          row["Total Remaining (points)"] + total["Total Remaining (points)"],
      };
    },
    {
      Name: `Total`,
      "Current Tier": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Revenue (THB)": 0,
      "Total Remaining (points)": 0,
    }
  );
};

const mapTierReport = (datas) => {
  return datas.map((t) => ({
    name: t.name,
    Members: t.memberNum,
    Revenue: t.revenue,
    Transactions: t.transactions,
    "Big spender": t.bigSpenderNum,
    Frequent: t.frequentNum,
    "Most Frequent Category": getMostOccurenceInArray(t.frequentCat).sort(
      (a, b) => a.localeCompare(b)
    )[0],
    "Most Expensive Category": getMostOccurenceInArray(t.expenseCat).sort(
      (a, b) => a.localeCompare(b)
    )[0],
    "Most Frequent Product": getMostOccurenceInArray(t.frequentProduct).sort(
      (a, b) => a.localeCompare(b)
    )[0],

    "Most Expensive Product": getMostOccurenceInArray(t.expenseProduct).sort(
      (a, b) => a.localeCompare(b)
    )[0],
  }));
};
const makeTierSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      if (isNaN(row["Revenue"])) {
        row["Revenue"] = 0;
      }
      if (isNaN(row["Transactions"])) {
        row["Transactions"] = 0;
      }
      return {
        name: "Total",
        Members: total["Members"] + (row["Members"] ?? 0),
        Revenue: total["Revenue"] + (row["Revenue"] ?? 0),
        Transactions: total["Transactions"] + (row["Transactions"] ?? 0),
        "Big spender": total["Big spender"] + (row["Big spender"] ?? 0),
        Frequent: total["Frequent"] + (row["Frequent"] ?? 0),
        "Most Frequent Category": "",
        "Most Expensive Category": "",
        "Most Frequent Product": "",

        "Most Expensive Product": "",
      };
    },
    {
      name: "Total",
      Members: 0,
      Revenue: 0,
      Transactions: 0,
      "Big spender": 0,
      Frequent: 0,
      "Most Frequent Category": "",
      "Most Expensive Category": "",
      "Most Frequent Product": "",

      "Most Expensive Product": "",
    }
  );
};

export {
  mapTotalReport,
  makeTotalSummary,
  mapEarnReport,
  makeEarnSummary,
  mapRedeemReport,
  makeRedeemSummary,
  mapRemainingReport,
  makeRemainingSummary,
  mapTierReport,
  makeTierSummary,
};
